import { BaseEntity } from '@base-entities';
import { HeadquarterTransformer } from '../transformers';
import { IBaseTransformerRepository } from '@base-repositories';

export function makeHeadquarterTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new HeadquarterTransformer<E>();
}
